import { useEffect, useRef } from 'react'

const useEnterClick = (onEnterClick: () => void) => {
  const action = useRef(onEnterClick)
  action.current = onEnterClick

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Enter') {
        action.current()
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [])
}

export default useEnterClick